module.exports = __webpack_public_path__ + "img/returns-white.8d735d22.svg";